const autoNgTemplateLoaderTemplate1 = require('./box-selector.html');

import angular from 'angular';

import './box-selector.css';

import controller from './box-selector.controller';

angular.module('portainer.app').component('boxSelector', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
  bindings: {
    radioName: '@',
    ngModel: '=',
    options: '<',
    onChange: '<',
  },
});

export function buildOption(id, icon, label, description, value) {
  return { id, icon, label, description, value };
}
